import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import { PrivateRoute } from './layout/PrivateRoute';
import { PublicRoute } from './layout/PublicRoute';
import Frame from './layout/Frame';
import Organization from './pages/Orgs/Organization';
import CredMain from './pages/Cred/CredMain';
import { NotFound } from './pages/Cred/NotFound';
import { NoPermission } from './pages/Cred/NoPermission';
import { OuPreSelection } from './pages/Cred/OuPreSelection';
import RedirectAccount from './layout/RedirectAccount';
import { LoginRedirect } from './layout/LoginRedirect';

interface IProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

function Routing(props: IProps) {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/" element={<Home />} {...props} />
          </Route>
          <Route
            path="/login-redirect"
            element={<LoginRedirect />}
            {...props}
          />
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/organization"
                element={
                  <Frame {...props} hideSideMenu>
                    <Organization />
                  </Frame>
                }
                {...props}
              />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/cred"
                element={
                  <Frame {...props} hideSideMenu>
                    <CredMain />
                  </Frame>
                }
                // {...props}
              >
                <Route path="no-permission" element={<NoPermission />} />
                <Route path="*" element={<OuPreSelection />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Routing;
